const FieldServiceFactory = ({ HTTPFields }) => {
    return {
        getGrowers: () => HTTPFields.get(`growers`).then((res) => res.data),
        getFarms: () => HTTPFields.get(`farms`).then((res) => res.data),
        getFields: () => HTTPFields.get(`fields`).then((res) => res.data),
        getField: (id) => HTTPFields.get(`fields/${id}`).then((res) => res.data[0]),
        getLastTask: () => HTTPFields.get('tasks?limit=1').then((res) => {
            if (!res.data.length) {
                return null;
            }
            const fieldsQuery = HTTPFields.get('fields/' + res.data[0].fieldId);
            const productQuery = res.data[0].productId
                ? HTTPFields.get('products/' + res.data[0].productId)
                : Promise.resolve({
                    data: {
                        name: 'N/A',
                    },
                });
            return Promise.all([fieldsQuery, productQuery]).then((r) => {
                const [fields, product] = r;
                return {
                    ...res.data[0],
                    field: fields.data,
                    product: product.data,
                };
            });
        }),
        getTaskCountByDate: (fromDate) => {
            const serializedParams = Object.entries({ offset: 0, sort: 'ASC', orderBy: 'startDate', orderType: 'desc', startDate: fromDate, statuses: 'done' })
                .map((pair) => pair.map(encodeURIComponent).join('='))
                .join('&');
            return HTTPFields.get(`tasksAll?${serializedParams}`).then((res) => ({
                ...res.data,
            }));
        },
    };
};
export default FieldServiceFactory;
//# sourceMappingURL=field.api.js.map